import Vue from 'vue'
import Router from 'vue-router'

import Homepage from "../components/Homepage";
import CV from "../components/CV";
import About from "../components/About";
import Publications from "../components/Publications";
import Works from "../components/Works";
import AddInfo from "../components/AddInfo";
import Experiences from "../components/Experiences";
import Main from "../components/Main";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/cv/:item',
      name: 'CV',
      component: CV
    },
    {
      path: '/cv',
      name: 'CVMain',
      component: CV
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js